import { Breadcrumb, Button, Form, Input } from "antd";
import { CheckOutlined, CloseOutlined, HomeOutlined, LoginOutlined, SearchOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useState } from "react";
import { _adr } from "../../address";
import { searchDealer, startImpersonation } from "../../tools/impersonation";
import "../auxiliary/lookup/lookup.scss";
import "./loginAs.scss";

const ALLOWED = ["مشاهده داشبورد، گزارش‌ها و موجودی‌ها", "آپلود و اصلاح مدارک ناقص", "خدمات ۳۶۰ و جستجوی مشترکین"];
const BLOCKED = ["فروش سیم‌کارت، بسته و شارژ", "تعویض، تحویل حضوری و انتقال مالکیت", "واریز و برداشت کیف پول، پرداخت صورتحساب", "درخواست کیت سیم‌کارت"];

const LoginAs = () => {
	const [form] = Form.useForm();
	const [searching, setSearching] = useState(false);
	const [entering, setEntering] = useState(false);
	const [dealer, setDealer] = useState(null);
	const [error, setError] = useState("");

	const handleSearch = async ({ username }) => {
		setSearching(true);
		setDealer(null);
		setError("");
		const res = await searchDealer(username.trim());
		// HasError (404 unknown / inactive / not a dealer) -> show the server's Message, never call Start
		if (res.ok && res.data?.Username) setDealer({ username: res.data.Username, isActive: res.data.IsActive });
		else setError(res.message || "نام کاربر وارد شده صحیح نمی باشد");
		setSearching(false);
	};

	const handleEnter = async () => {
		setEntering(true);
		setError("");
		// on success the page reloads into the dealer's panel
		const res = await startImpersonation(dealer.username);
		if (!res.ok) {
			setError(res.message);
			setEntering(false);
		}
	};

	return (
		<div className="container-main container-login-as">
			<div className="g-hold-title-of-page">
				<Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: "ورود به عنوان" }]} />
				<div className="title-page">
					<h3>ورود به پنل نماینده</h3>
					<p>پنل یک نماینده را همان‌طور که خودش می‌بیند باز کنید؛ تمام این ورود در گزارش ثبت می‌شود.</p>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main lookup-page login-as-page">
					<div className="lookup-grid">
						<div className="lookup-main">
							<div className="lookup-mark" aria-hidden="true">
								<UserSwitchOutlined />
							</div>
							<h4>نماینده را پیدا کنید</h4>
							<p className="lookup-hint">نام کاربری نماینده را دقیق و کامل وارد کنید.</p>

							<Form
								form={form}
								onFinish={handleSearch}
								onValuesChange={() => {
									setDealer(null);
									setError("");
								}}>
								<div className="login-as-search">
									<Form.Item
										name="username"
										validateStatus={error ? "error" : undefined}
										help={error || undefined}
										rules={[{ required: true, whitespace: true, message: "نام کاربری نماینده را وارد کنید" }]}>
										<Input
											size="large"
											dir="ltr"
											autoComplete="off"
											allowClear
											autoFocus
											placeholder="dealer001"
											aria-label="نام کاربری نماینده"
											prefix={<SearchOutlined />}
										/>
									</Form.Item>
									<Button htmlType="submit" size="large" className="lookup-btn" loading={searching}>
										جستجو
									</Button>
								</div>
							</Form>

							{dealer && (
								<div className="login-as-result" role="status">
									<span className="login-as-avatar" aria-hidden="true">
										{dealer.username?.[0]?.toUpperCase()}
									</span>
									<div className="login-as-who">
										<strong dir="ltr">{dealer.username}</strong>
										<span className={dealer.isActive ? "is-active" : "is-inactive"}>{dealer.isActive ? "نماینده فعال" : "نماینده غیرفعال"}</span>
									</div>
									<Button type="primary" size="large" className="login-as-enter" icon={<LoginOutlined />} loading={entering} onClick={handleEnter}>
										ورود به پنل نماینده
									</Button>
								</div>
							)}
						</div>

						<aside className="lookup-aside" aria-label="دسترسی‌ها در حالت ورود به عنوان">
							<h5>در پنل نماینده می‌توانید</h5>
							<ul className="is-allowed">
								{ALLOWED.map((t) => (
									<li key={t}>
										<CheckOutlined aria-hidden="true" />
										{t}
									</li>
								))}
							</ul>
							<h5>غیرفعال است</h5>
							<ul className="is-blocked">
								{BLOCKED.map((t) => (
									<li key={t}>
										<CloseOutlined aria-hidden="true" />
										{t}
									</li>
								))}
							</ul>
							<p>برای خروج، دکمه «بازگشت به حساب کاربری» در نوار بالای صفحه را بزنید.</p>
						</aside>
					</div>
				</Content>
			</div>
		</div>
	);
};

export default LoginAs;
